<template>
    <div>
        <form @submit.prevent="submitMessage">
            <div class="form-group">
                <label class="form-label">{{$t('label.title')}}</label>
                <div class="input-group bg-white shadow-inset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent border-right-0">
                            <i class="fas fa-text"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                </div>
            </div>
             <div class="form-group">
                <label class="form-label">{{$t('subMenu.my_salon_message')}}</label>
                <textarea class="form-control" :placeholder="$t('subMenu.my_salon_message')" rows="8" v-model="message"></textarea>
            </div>
            <div class="border-top pt-3 text-left">
                <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnParent">{{$t('button_link.cancel')}}</button>
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.send_message')}}</button>
            </div>
        </form>
    </div>
</template>
<script>
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'messageForm',
    props:{
        isThirdLevel: Boolean
    },
    data(){
        return{
            title: '',
            message: ''
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.returnParent()
            }
            var parent = this.isThirdLevel ? this.$parent.$parent.$parent : this.$parent.$parent
            parent.isModalShow = false
        },
        setForm(title, message){
            this.title = title
            this.message = message
        },
        returnParent(){
            this.$emit('returnParent')
        },
        submitMessage(){
            let $vm = this
            var parent = $vm.isThirdLevel ? $vm.$parent.$parent.$parent : $vm.$parent.$parent

            var data = {
                title: this.message,
                message: this.title
            }
            $vm.$axios({
                method: 'post', 
                url: $vm.$api.MESSAGE,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.my_salon_message') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.sent')})
                    parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        }
    }
}
</script>